var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "gs1-details"
  }, [_c('div', {
    staticClass: "content mt-8 ml-3 gs1-content"
  }, [_vm.isGS1Code ? _c('div', {
    staticClass: "label font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.$t('gs1_digital_link_url')) + " ")]) : _c('div', {
    staticClass: "label font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.$t('default_url')) + " ")]), _c('div', {
    staticClass: "url-preview py-3 mono"
  }, [_vm._v(" " + _vm._s(_vm.urlPreview) + " "), _c('v-tooltip', {
    attrs: {
      "bottom": "",
      "content-class": "copy-url-tooltip"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": ""
          }
        }, 'v-btn', attrs, false), Object.assign({}, on, {
          click: _vm.copyUrlToClipboard
        })), [_c('v-icon', {
          attrs: {
            "color": "primary"
          }
        }, [_vm._v("mdi-content-copy")])], 1)];
      }
    }])
  }, [_c('span', {
    staticClass: "black--text body-2"
  }, [_vm._v(_vm._s(_vm.$t('copy_url')))])])], 1), _vm.isGS1Code || _vm.isUpgradingToGs1 ? _c('v-form', {
    ref: "gs1-form",
    staticClass: "pt-0 pb-8",
    model: {
      value: _vm.isGs1CodeFormValid,
      callback: function ($$v) {
        _vm.isGs1CodeFormValid = $$v;
      },
      expression: "isGs1CodeFormValid"
    }
  }, [_c('div', {
    staticClass: "label mb-5 font-weight-bold"
  }, [_vm._v(_vm._s(_vm.$t('primary_keys')))]), _c('v-row', {
    staticClass: "ma-0"
  }, [_c('v-col', {
    staticClass: "mr-3",
    attrs: {
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "small": "",
      "dense": "",
      "outlined": "",
      "label": `(01) ${_vm.$t('gtin')}*`,
      "hint": _vm.$t('gs1_gtin_hint'),
      "counter": 14,
      "rules": _vm.gtinRules,
      "error-messages": _vm.gtinErrorMessages,
      "required": "",
      "disabled": _vm.isGs1FormLocked,
      "validate-on-blur": ""
    },
    model: {
      value: _vm.form.gs1_gtin,
      callback: function ($$v) {
        _vm.$set(_vm.form, "gs1_gtin", $$v);
      },
      expression: "form.gs1_gtin"
    }
  })], 1)], 1), _c('div', {
    staticClass: "label my-3 font-weight-bold"
  }, [_vm._v(_vm._s(_vm.$t('key_qualifiers')))]), _c('v-row', {
    staticClass: "ma-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": `(22) ${_vm.$t('gs1_cpv')}`,
      "hint": _vm.$t('gs1_cpv_hint'),
      "small": "",
      "dense": "",
      "outlined": "",
      "persistent-hint": "",
      "counter": 20,
      "rules": _vm.fieldRules,
      "required": false,
      "disabled": _vm.isGs1FormLocked,
      "validate-on-blur": ""
    },
    model: {
      value: _vm.form.gs1_cpv,
      callback: function ($$v) {
        _vm.$set(_vm.form, "gs1_cpv", $$v);
      },
      expression: "form.gs1_cpv"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "small": "",
      "dense": "",
      "outlined": "",
      "label": `(10) ${_vm.$t('gs1_lot')}`,
      "hint": _vm.$t('gs1_lot_batch_number'),
      "persistent-hint": "",
      "counter": 20,
      "rules": _vm.fieldRules,
      "required": false,
      "disabled": _vm.isGs1FormLocked,
      "validate-on-blur": ""
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function () {
        return [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function (_ref2) {
              var on = _ref2.on,
                attrs = _ref2.attrs;
              return [_c('v-icon', _vm._g(_vm._b({
                attrs: {
                  "disabled": _vm.isGs1FormLocked
                }
              }, 'v-icon', attrs, false), Object.assign({}, on, {
                click: _vm.handleRefreshIconClick
              })), [_vm._v(" mdi-refresh ")])];
            }
          }], null, false, 2880041650)
        }, [_c('span', {
          staticClass: "black--text body-2"
        }, [_vm._v(_vm._s(_vm.$t('gs1_generate_batch_number')))])])];
      },
      proxy: true
    }], null, false, 2176331752),
    model: {
      value: _vm.form.gs1_lot,
      callback: function ($$v) {
        _vm.$set(_vm.form, "gs1_lot", $$v);
      },
      expression: "form.gs1_lot"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "small": "",
      "dense": "",
      "outlined": "",
      "label": `(21) ${_vm.$t('gs1_serial_number')}`,
      "hint": _vm.$t('gs1_serial_number_hint'),
      "persistent-hint": "",
      "counter": 20,
      "rules": _vm.fieldRules,
      "required": false,
      "disabled": _vm.isGs1FormLocked,
      "validate-on-blur": ""
    },
    model: {
      value: _vm.form.gs1_serial,
      callback: function ($$v) {
        _vm.$set(_vm.form, "gs1_serial", $$v);
      },
      expression: "form.gs1_serial"
    }
  })], 1)], 1), _c('div', {
    staticClass: "d-flex flex-column align-start mt-4 mb-3"
  }, [_c('div', {
    staticClass: "label mb-1 font-weight-bold"
  }, [_vm._v(_vm._s(_vm.$t('qrcode_gs1_data_attributes')))]), _c('div', {
    staticClass: "mb-4"
  }, [_vm._v(_vm._s(_vm.$t('qrcode_data_attributes_caption')))]), _vm.dataAttributes.length < _vm.dataAttributeOptions.length ? _c('v-btn', {
    staticClass: "my-1 pa-2",
    attrs: {
      "disabled": _vm.isGs1FormLocked,
      "color": "primary",
      "text": "",
      "large": ""
    },
    on: {
      "click": function ($event) {
        return _vm.addDataAttribute();
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("mdi-plus-circle")]), _vm._v(" " + _vm._s(_vm.$t('qrcode_add_data_attributes')) + " ")], 1) : _vm._e()], 1), _vm._l(_vm.dataAttributes, function (attribute, index) {
    return _c('v-row', {
      key: index,
      staticClass: "ma-0"
    }, [_c('v-col', {
      attrs: {
        "cols": "12",
        "md": "6"
      }
    }, [_c('v-select', {
      attrs: {
        "small": "",
        "dense": "",
        "outlined": "",
        "items": _vm.dataAttributeOptions,
        "item-text": "text",
        "item-value": "value",
        "rules": _vm.dataAttributeKeyRules(attribute),
        "disabled": _vm.isGs1FormLocked
      },
      model: {
        value: attribute.key,
        callback: function ($$v) {
          _vm.$set(attribute, "key", $$v);
        },
        expression: "attribute.key"
      }
    })], 1), _c('v-col', {
      attrs: {
        "cols": "12",
        "md": "5"
      }
    }, [_c('v-text-field', {
      attrs: {
        "small": "",
        "dense": "",
        "outlined": "",
        "persistent-hint": "",
        "counter": 2,
        "rules": _vm.dataAttributeValueRules(attribute),
        "disabled": _vm.isGs1FormLocked
      },
      model: {
        value: attribute.value,
        callback: function ($$v) {
          _vm.$set(attribute, "value", $$v);
        },
        expression: "attribute.value"
      }
    })], 1), _c('v-col', {
      attrs: {
        "cols": "auto"
      }
    }, [_c('v-btn', {
      attrs: {
        "disabled": _vm.isGs1FormLocked,
        "color": "red",
        "icon": ""
      },
      on: {
        "click": function ($event) {
          return _vm.removeDataAttribute(index);
        }
      }
    }, [_c('v-icon', [_vm._v("mdi-close-circle")])], 1)], 1)], 1);
  })], 2) : _vm._e()], 1), _c('div', {
    staticClass: "actions-ctn"
  }, [!_vm.isGS1Code && !_vm.isUpgradingToGs1 ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "raised": ""
    },
    on: {
      "click": _vm.upgradeToGs1
    }
  }, [_c('v-icon', [_vm._v("mdi-plus")]), _vm._v(" " + _vm._s(_vm.$t('create_gs1_digital_link')) + " ")], 1) : _vm._e(), _vm.isUpgradingToGs1 || !_vm.isGs1FormLocked && _vm.isGS1Code ? _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "text": "",
      "outlined": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.cancel();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('cancel')) + " ")]) : _vm._e(), _vm.isGs1FormLocked && _vm.isGS1Code ? _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "text": "",
      "outlined": "",
      "color": "#F22A42"
    },
    on: {
      "click": function ($event) {
        return _vm.openUnlockModalConfirmation();
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-lock-open-outline")]), _vm._v(" " + _vm._s(_vm.$t('unlock_editing')) + " ")], 1) : _vm._e(), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isGS1Code || _vm.isUpgradingToGs1,
      expression: "isGS1Code || isUpgradingToGs1"
    }],
    attrs: {
      "disabled": _vm.saving || !_vm.hasUnsavedChanges,
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.save();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('save')) + " ")])], 1), _c('v-dialog', {
    attrs: {
      "width": "450"
    },
    model: {
      value: _vm.unlockModal,
      callback: function ($$v) {
        _vm.unlockModal = $$v;
      },
      expression: "unlockModal"
    }
  }, [_c('v-card', {
    attrs: {
      "scrollable": ""
    }
  }, [_c('v-card-title', {
    staticClass: "text-break"
  }, [_vm._v(" " + _vm._s(_vm.$t('unlock_modal_title')) + " ")]), _c('v-row', {
    staticClass: "pa-5 ma-0"
  }, [_c('v-col', {
    staticClass: "py-0"
  }, [_c('div', {
    staticClass: "red--text font-weight-bold"
  }, [_vm._v(_vm._s(_vm.$t('unlock_modal_decription_warning')))]), _c('div', {
    staticClass: "mt-3"
  }, [_vm._v(" " + _vm._s(_vm.$t('unlock_modal_decription_1'))), _c('br'), _c('br'), _vm._v(" " + _vm._s(_vm.$t('unlock_modal_decription_2')) + " ")])])], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.unlockModal = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel')))]), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.unlockForm();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('unlock_editing')))])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }